import { responseHandleService } from './ResponseHandleService';
import AuthenticationService from './AuthenticationService';
import axios from 'axios';

export const procedureService = {
  getAll,
  createOrUpdate,
  deleteProcedure
};
const requestOptions = {
  method: 'GET',
  headers: {
    Accept: 'application/json',
    'Content-type': 'application/json'
  }
};

function getAll(pageNumber) {
  let url = `${
    process.env.REACT_APP_API_URL}/api/procedures/?page[number]=${pageNumber ? pageNumber : 1}`;

  return fetch(url, requestOptions)
    .then(responseHandleService.handleResponse)
    .catch(error => console.log(error));
}
function createOrUpdate(newProcedure) {
  const requestOptions = {
    method: newProcedure.id ? 'PUT' : 'POST',
    headers: {
      Accept: 'application/json'
    },
    body: createBodyRequest(newProcedure)
  };

  let authentication = new AuthenticationService();

  console.log(authentication.loggedIn());

  if (authentication.loggedIn()) {
    requestOptions.headers['Authorization'] =authentication.getToken();
  }

  const url = `${process.env.REACT_APP_API_URL}/api/procedures${
    newProcedure.id ? `/${newProcedure.id}` : ''
  }`;

  return fetch(url, requestOptions).then(responseHandleService.handleResponse);
}
function createBodyRequest(procedure) {
  let formData = new FormData();

  formData.append('procedure[title]', procedure.title);
  formData.append('procedure[date]', procedure.date);
  const document = procedure.document;

  if (document) {
    if (document.url) {
      formData.append(`procedure[document]`, document.url);
    } else {
      formData.append(`procedure[document]`, document, document.name);
    }
  }

  return formData;
}
function deleteProcedure(procedureId) {
  const requestOptionsDelete = {
    headers: {
      Accept: 'application/json'
    }
  };
  this.authentication = new AuthenticationService();

  if (this.authentication.loggedIn()) {
    requestOptionsDelete.headers['Authorization'] =this.authentication.getToken();
  }
  let url = `${process.env.REACT_APP_API_URL}/api/procedures/${procedureId}`;

  return axios.delete(url, requestOptionsDelete);
}
